

<headerCustom></headerCustom>

<div class="main-content">
    <div class="reportDashboardContainer customizeRtsScrollBar">
        <div class="reportDashboardMainholder">
            <div class="container">
                <div class="pageHeading">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-center fontCustomCss-4">Welcome!</div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center dashboardBody">
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" (click)="gotoNextPage($event, '/ibu')">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <!-- <img src="assets/ibu.png" class="img-fluid" /> -->
                                <i class="fa fa-users"></i>
                            </div>
                            <button type="button">BU</button>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Business Unit</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" (click)="gotoNextPage($event, '/tower')">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <!-- <img src="assets/work_allocation.png" class="img-fluid" /> -->
                                <i class="fas fa-layer-group"></i>
                            </div>
                            <button type="button">Towers</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Towers</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" (click)="gotoNextPage($event, '/manageUsers')">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fas fa-user-tie"></i>
                            </div>
                            <button type="button">Management User</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Management Users</span>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" (click)="gotoNextPage($event, '/behSkillMaster')">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-user-cog"></i>
                            </div>
                            <button type="button">Behavioral Skill Config</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Behavioral Skill Details</span>
                        </div>
                    </div>
                    <!-- <img src="assets/functional-skill.png" class="img-fluid" /> -->
                    <div class="col-md-3 col-sm-6 col-xs-12 dashboard_mainbox" (click)="gotoNextPage($event, '/funSkillMaster')">
                        <div class="reportDashboard-item text-center">
                            <div class="icon">
                                <i class="fa fa-tasks"></i>
                            </div>
                            <button type="button">Functional Skill Config</button>
                            <div class="line-dec"></div>
                        </div>
                        <div class="reportDashboard-text text-center">
                            <span>Add/Update Functional Skill Details</span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer">
    <p>  &copy; 2021 NIIT Talent Readiness, All rights reserved. Powered by NEC.</p>
</div>


<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>